import {createFileRoute} from '@tanstack/react-router';

import {RolesPage} from '@/modules/admin-roles/pages/RolesPage';

export const Route = createFileRoute('/_authenticated/admin/roles/')({
  component: RolesPage,
});
